import { FaCarSide, FaCreditCard, FaExchangeAlt, FaRoad, FaCheckCircle, FaHeadset } from 'react-icons/fa';

const features = [
    { 
        id: 1,
        icon: <FaCarSide />, // Car-side icon for Wide Selection
        title: 'Wide Selection',
        description: 'Explore an extensive range of vehicles to suit every need, from compact cars to luxury models.',
    },
    {
        id: 2,
        icon: <FaCreditCard />, // Credit card icon for Financing Options
        title: 'Financing Options',
        description: 'Get flexible financing solutions to make purchasing your dream car easy and affordable.',
    },
    {
        id: 3,
        icon: <FaExchangeAlt />, // Exchange icon for Trade-In Deals
        title: 'Trade-In Deals',
        description: 'Trade in your old vehicle and get a great deal on a new car with our hassle-free process.',
    },
    {
        id: 4,
        icon: <FaRoad />, // Road icon for Test Drive
        title: 'Test Drive',
        description: "Experience your potential new car firsthand with a test drive to ensure it's the right fit.",
    },
    {
        id: 5,
        icon: <FaCheckCircle />, // Check-circle icon for Certified Pre-Owned
        title: 'Certified Pre-Owned',
        description: 'Choose from a selection of certified pre-owned vehicles that meet our high-quality standards.',
    },
    {
        id: 6,
        icon: <FaHeadset />, // Headset icon for Customer Support
        title: 'Customer Support',
        description: 'Our dedicated team is always here to assist you with any questions before, during, and after the purchase.',
    },
];

export default features;